import { render, staticRenderFns } from "./CharacterForm.vue?vue&type=template&id=1152725f&scoped=true"
import script from "./CharacterForm.vue?vue&type=script&lang=ts"
export * from "./CharacterForm.vue?vue&type=script&lang=ts"
import style0 from "./CharacterForm.vue?vue&type=style&index=0&id=1152725f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1152725f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1152725f')) {
      api.createRecord('1152725f', component.options)
    } else {
      api.reload('1152725f', component.options)
    }
    module.hot.accept("./CharacterForm.vue?vue&type=template&id=1152725f&scoped=true", function () {
      api.rerender('1152725f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CharacterForm.vue"
export default component.exports